export default __webpack_public_path__ + "static/media/romatherapy-breakfast-bowl.fb15ff94.jpg";